import ChangePassword from './ChangePasswordContainer'

export default ChangePassword



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js